<template>
  <!-- 左侧菜单 -->
  <div
    class="page-header"
    v-if="routerPath.children.length > 0 && indexActive.length > 0"
  >
    <div
      v-if="routerPath.children[indexActive[0]].children[indexActive[1]].hidden"
    >
      <div class="title">
        <i class="el-icon-back back" @click="back"></i>
        {{
          routerPath.children[indexActive[0]].children[indexActive[1]].meta
            .title
        }}
      </div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{
          routerPath.children[indexActive[0]].meta.title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          routerPath.children[indexActive[0]].children[indexActive[1]].meta
            .title
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-else>
      <div class="title">
        {{
          routerPath.children[indexActive[0]].children[indexActive[1]].meta
            .title
        }}
      </div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{
          routerPath.children[indexActive[0]].meta.title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          routerPath.children[indexActive[0]].children[indexActive[1]].meta
            .title
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  watch: {
    routerPath: {
      handler() {
        /* console.log(this.routerPath);
        console.log(
          this.routerPath.children[this.indexActive[0]].children[
            this.indexActive[1]
          ].meta.title
        ); */
      },
    },
  },
  computed: {
    ...mapState(["indexActive", "routerPath"]),
  },
  mounted() {
    //console.log(this.routerPath);
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.back {
  font-size: 26px;
  margin-right: 16px;
  cursor: pointer;
}
</style>